import React, { useEffect, useState } from "react";
import "./style.css";
import Loader from "../../components/loader/Loader";
import { getAllUsers } from "../../../services/Admin";
import formatDate from "../../../utils/formatDate";
import CustomTable from "../../components/custom-table/CustomTable";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { FaEdit } from 'react-icons/fa';


function AllUser() {
  const [isLoading, setIsLoading] = useState(true);
  const [allMemberDetails, setAllMemberDetails] = useState([]);

  const columns = [
    {
      Header: "S.no",
      accessor: "sno",
    },
    {
      Header: "Full Name",
      accessor: "name",
    },
    {
      Header: "Update User",
      accessor: "updateUser",
    },
    {
      Header: "Email Address",
      accessor: "email",
    },
    {
      Header: "Phone Number",
      accessor: "phone",
    },
    {
      Header: "Account Created",
      accessor: "date",
    },
    {
      Header: "CGT Coins",
      accessor: "CGTCoins",
    },
    {
      Header: "Update Wallet",
      accessor: "updateWallet",
    },
    {
      Header: "Referral Reward Stage",
      accessor: "referralRewardStatus",
    },
    {
      Header: "Block Status",
      accessor: "loginStatus",
    },
  ];


  const fetchAllUsers = async () => {
     try {
          const response = await getAllUsers();
            // console.log(response);
            // setAllMemberDetails(response.data);
            const newArr = response.map((entry, index) => ({
              "sno": index + 1,
              "name": entry.name || "N/A",
              "updateUser": (<Link className="table-link" to={`../update-user?email=${entry.email}`}>
              Update User <FaEdit />
            </Link>
          ) || "N/A",
              "email": entry.email || "N/A",
              "phone": entry.phone || "N/A",
              "date": formatDate(entry.date) || "N/A",
              "CGTCoins": entry.wallet ? entry.wallet.balance : 0 || 0,
              "updateWallet": (<Link className="table-link" to={`../update-wallet?email=${entry.email}`}>
                Update Wallet <FaEdit />
              </Link>
            ) || "N/A",
              "referralRewardStatus": entry.referralRewardStatus || 0,
              "loginStatus": entry.loginStatus || "Not Blocked",
      
             }));
            setAllMemberDetails(newArr);
        } catch (error) {
          console.log(error);
          toast.error("Something Went wrong!!");
        } finally {
          setIsLoading(false);
        }
    }

      useEffect(() => {
        fetchAllUsers();
    
      }, [])


  return (
    <>
    {isLoading ? (
      <Loader />
    ) : (
      <div className="investment-history">
        <h1 className="main-heading">All Users</h1>
        <br />
        <br />

        <CustomTable
          data={allMemberDetails}
          columns={columns}
          heading="All User details"
        />
      </div>
    )}
  </>
  );
}

export default AllUser;
